import React from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

const Widerruf = ({ user, onLogout }) => {
  return (
    <>
      <Helmet>
        <title>Widerruf & Kündigung - EventConnect</title>
        <meta name="description" content="Widerrufsbelehrung und Kündigungsrichtlinien für EventConnect Abonnements" />
      </Helmet>
      
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Navbar user={user} onLogout={onLogout} />
        
        <main className="flex-grow mx-auto w-full px-4 pt-24 pb-12 max-w-4xl">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-8 text-gray-900 break-words">Widerruf & Kündigung</h1>

          {/* Widerrufsbelehrung */}
          <section className="bg-white rounded-lg shadow-sm p-4 sm:p-6 md:p-8 mb-8">
            <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-900 break-words">Widerrufsbelehrung für Verbraucher</h2>

            <div className="break-words">
              <h3 className="text-xl font-semibold mt-6 mb-3">Widerrufsrecht</h3>
              <p className="mb-4">
                Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
              </p>
              <p className="mb-4">
                Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
              </p>
              <p className="mb-4">
                Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (EventConnect, Hayri Tugkan Diyaroglu, 
                Kontakt: <a href="mailto:kontakt@evconn.de" className="text-[#2B2142] hover:underline">kontakt@evconn.de</a>) 
                mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder E-Mail) über Ihren 
                Entschluss, diesen Vertrag zu widerrufen, informieren.
              </p>
              <p className="mb-4">
                Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">Folgen des Widerrufs</h3>
              <p className="mb-4">
                Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, 
                unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über 
                Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe 
                Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde 
                ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">Besondere Hinweise</h3>
              <p className="mb-4">
                Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, so haben Sie uns 
                einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von der 
                Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits erbrachten Dienstleistungen 
                im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht.
              </p>
            </div>
          </section>

          {/* Muster-Widerrufsformular */}
          <section className="bg-white rounded-lg shadow-sm p-4 sm:p-6 md:p-8 mb-8">
            <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-900 break-words">Muster-Widerrufsformular</h2>

            <div className="bg-gray-50 border-2 border-gray-200 rounded-lg p-3 sm:p-6 font-mono text-sm break-words">
              <p className="mb-4">
                An<br />
                EventConnect<br />
                Hayri Tugkan Diyaroglu<br />
                E-Mail: kontakt@evconn.de
              </p>
              
              <p className="mb-4">
                Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die Erbringung der folgenden Dienstleistung (*)
              </p>
              
              <div className="mb-4">
                Bestellt am (*) / erhalten am (*):
                <span className="block border-b border-gray-400 h-6 w-full max-w-xs" />
              </div>

              <div className="mb-4">
                Name des/der Verbraucher(s):
                <span className="block border-b border-gray-400 h-6 w-full max-w-xs" />
              </div>

              <div className="mb-4">
                Anschrift des/der Verbraucher(s):
                <span className="block border-b border-gray-400 h-6 w-full max-w-xs" />
                <span className="block border-b border-gray-400 h-6 w-full max-w-xs" />
              </div>

              <div className="mb-4">
                Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier):
                <span className="block border-b border-gray-400 h-6 w-full max-w-xs" />
              </div>

              <div>
                Datum:
                <span className="block border-b border-gray-400 h-6 w-full max-w-xs" />
              </div>
              
              <p className="mt-4 text-xs text-gray-600">
                (*) Unzutreffendes streichen.
              </p>
            </div>
          </section>

          {/* Kündigungsbelehrung */}
          <section className="bg-white rounded-lg shadow-sm p-4 sm:p-6 md:p-8 mb-8">
            <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-900 break-words">Kündigung von Abonnements</h2>

            <div className="break-words">
              <h3 className="text-xl font-semibold mt-6 mb-3">Kündigungsrecht</h3>
              <p className="mb-4">
                Abonnements bei EventConnect können jederzeit gekündigt werden. Die Kündigung wird zum Ende des aktuellen 
                Abrechnungszeitraums wirksam.
              </p>
              <p className="mb-4">
                <strong>Monatspläne (Basic Monat, Plus, Pro):</strong> Kündigung wirksam zum Ende der laufenden Monatsperiode.
                <br />
                <strong>Jahresplan (Basic Jahresplan):</strong> Kündigung wirksam zum Ende der laufenden 12-Monats-Periode.
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">Kündigungsfrist</h3>
              <p className="mb-4">
                Die Kündigung kann jederzeit erklärt werden. Sie wird zum Ende der aktuellen Abrechnungsperiode wirksam.
                Es ist keine Einhaltung einer bestimmten Frist erforderlich - die Kündigung greift automatisch zum 
                Periodenende (bei Monatsplänen zum Monatsende, beim Jahresplan zum Jahresende).
              </p>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">Wie Sie kündigen können</h3>
              <p className="mb-4">
                Sie können Ihr Abonnement auf folgende Weise kündigen:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li className="mb-2">
                  <strong>Über Ihr Dashboard:</strong> Loggen Sie sich ein und gehen Sie zu 
                  "Abo & Abrechnung" → "Abonnement kündigen"
                </li>
                <li className="mb-2">
                  <strong>Per E-Mail:</strong> Senden Sie eine E-Mail an{' '}
                  <a href="mailto:kontakt@evconn.de" className="text-[#2B2142] hover:underline">
                    kontakt@evconn.de
                  </a>{' '}
                  mit Ihrer Kündigungsabsicht und Ihrer registrierten E-Mail-Adresse
                </li>
                <li className="mb-2">
                  <strong>Schriftlich:</strong> Senden Sie uns einen Brief mit Ihrer Kündigungsabsicht
                </li>
              </ul>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">Was passiert nach der Kündigung?</h3>
              <p className="mb-4">
                Nach der Kündigung:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li className="mb-2">
                  Ihr Abonnement bleibt bis zum Ende des bezahlten Zeitraums aktiv
                </li>
                <li className="mb-2">
                  Es erfolgen keine weiteren automatischen Abbuchungen
                </li>
                <li className="mb-2">
                  Nach Ablauf des Abonnements wird Ihr Provider-Profil nicht mehr in der Suche angezeigt
                </li>
                <li className="mb-2">
                  Ihre Daten bleiben gespeichert und Sie können das Abonnement jederzeit wieder aktivieren
                </li>
              </ul>
              
              <h3 className="text-xl font-semibold mt-6 mb-3">Account-Löschung</h3>
              <p className="mb-4">
                Wenn Sie Ihren Account komplett löschen möchten (inklusive aller Daten), können Sie dies in den 
                Einstellungen unter "Account löschen" tun. Bitte beachten Sie, dass eine Account-Löschung nicht 
                möglich ist, solange ein aktives Abonnement besteht. Kündigen Sie zunächst Ihr Abonnement und 
                warten Sie bis zum Ablauf des bezahlten Zeitraums.
              </p>
              
              <div className="bg-[#FFF0D1]/30 border-l-4 border-[#2B2142] p-4 mt-6">
                <p className="text-sm text-[#2B2142]">
                  <strong>Wichtig:</strong> Eine Erstattung bereits bezahlter Beträge ist nur im Rahmen des 
                  14-tägigen Widerrufsrechts möglich. Nach Ablauf dieser Frist erfolgt keine anteilige Rückerstattung 
                  bei vorzeitiger Kündigung.
                </p>
              </div>
            </div>
          </section>

          {/* Kontakt */}
          <section className="bg-white rounded-lg shadow-sm p-4 sm:p-6 md:p-8">
            <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-900 break-words">Kontakt</h2>
            <p className="mb-4">
              Bei Fragen zu Widerruf oder Kündigung kontaktieren Sie uns gerne:
            </p>
            <div className="space-y-2">
              <p><strong>EventConnect</strong></p>
              <p>Hayri Tugkan Diyaroglu</p>
              <p>E-Mail: <a href="mailto:kontakt@evconn.de" className="text-[#2B2142] hover:underline">kontakt@evconn.de</a></p>
            </div>
          </section>
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default Widerruf;
